// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-contact-js": () => import("./../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-product-glasstop-js": () => import("./../src/pages/Product/glasstop.js" /* webpackChunkName: "component---src-pages-product-glasstop-js" */),
  "component---src-pages-product-steel-js": () => import("./../src/pages/Product/steel.js" /* webpackChunkName: "component---src-pages-product-steel-js" */)
}

